import {omit} from 'lodash';

import {createResourcesUpdatedReducer} from '../../../helpers/models/resourceHelpers';
import {CustomFieldModel} from '../../../models/api/customFieldModel';
import {AppAction} from '../../appActions';
import {ResourceMap} from '../../appTypes';
import {DataGroupsActionsEnum} from '../dataGroupsActions';
import {CustomFieldsActionsEnum} from './customFieldsActions';

const customFieldsUpdatedReducer = createResourcesUpdatedReducer(
  'customFields',
  (customField) => customField.id,
);

export function customFieldsReducer(
  state: ResourceMap<CustomFieldModel>,
  action: AppAction,
): ResourceMap<CustomFieldModel> {
  switch (action.type) {
    // Data Group.
    case DataGroupsActionsEnum.DATA_UPDATED:
      return customFieldsUpdatedReducer(state, action);

    // Single custom field update.
    case CustomFieldsActionsEnum.CUSTOM_FIELD_UPDATED:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };

    // Single custom field deletion.
    case CustomFieldsActionsEnum.CUSTOM_FIELD_DELETED:
      return omit(state, action.payload);

    default:
      return state;
  }
}
